import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Classify',
      component: () => import('./views/Classify')
    },
    {
      path: '/detail',
      name: 'detail',
      component: () => import('./views/Detail')
    },
    {
      path: '/certificate',
      name: 'Ccertificate',
      component: () => import('./views/Certificate')
    },
    {
      path: '/Virtualdetail',
      name: 'Virtualdetail',
      component: () => import('./views/Virtualdetail')
    },
  ]
});

export default router

